/** A table's rules preset, as the block stores it. */
export type TableBorders = "booktabs" | "grid" | "none";

/** A stored rules preset, or null when absent or unknown. */
export function readBorders(v: unknown): TableBorders | null {
  return v === "booktabs" || v === "grid" || v === "none" ? v : null;
}
